import React from "react";
import { Stack } from "@mui/system";
import { Button, Typography } from "@mui/material";
import IconValueVisual from "../visuals/IconValueVisual";

export interface HotelCardProps {
  image: string;
  eventName: string;
  location: string;
  onCheckIn: () => void;
}
const HotelCard = ({
  image,
  eventName,
  location,
  onCheckIn
}: HotelCardProps) => {
  return (
    <Stack
      border="2px solid #E7E7E7"
      direction="row"
      py={2}
      px={3}
      boxShadow="1px 1px 4px 0px #00000040"
      spacing={2}
    >
      <Stack spacing={2} flex={1} direction="row">
        <Stack>
          <img src={image} alt="" width="71px" height="71px" />
        </Stack>
        <Stack justifyContent="space-between">
          <Typography variant="h4" fontWeight={700}>
            {eventName}
          </Typography>
          <IconValueVisual icon="far fa-map-marker-alt" value={location} />
        </Stack>
      </Stack>
      <Stack justifyContent="center">
        <Button
          color="primary"
          variant="outlined"
          onClick={onCheckIn}
          className="font-primary"
        >
          Check In
        </Button>
      </Stack>
    </Stack>
  );
};

export default HotelCard;
